type ReLoginMethodNoticeProps = {
  onLogout: () => void;
  className?: string;
};

export function ReLoginMethodNotice({ onLogout, className = "" }: ReLoginMethodNoticeProps) {
  return (
    <div className={`border-l-4 border-[#E8B2A8] bg-[#FFF3F1] px-4 py-3 ${className}`}>
      <p className="text-xs font-black text-[#A1493E]">登録済みなのに利用できない場合</p>
      <p className="mt-2 text-xs leading-5 text-[#6B5851]">
        別のログイン方法で入っている可能性があります。LINEで始めた方は、ログアウトして「LINEでログイン」から入り直してください。Googleで始めた方は、Googleログインから入り直してください。
      </p>
      <button
        type="button"
        onClick={onLogout}
        className="mt-3 w-full rounded-xl bg-[#A1493E] px-4 py-3 text-xs font-black text-white transition hover:bg-[#8c3e34] active:scale-[0.99]"
      >
        ログアウトしてログインし直す
      </button>
    </div>
  );
}
